import { FC } from 'react';
import { RedirectIcon } from 'assets/icons';
import DateUtils from 'utils/dateUtils';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { SuggestedAdjustment } from '../payrun.model';
import { getSuggestedAdjustmentTitle } from '../utils';
import { SuggestedAdjustmentType } from '../constants';
import SuggestedAdjustmentDataCard from './SuggestedAdjustmentDataCard';
import { openInNewTab } from 'utils/commonUtils';
import routesPath from 'routes/RoutesPath';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
interface ReviewSuggestionDataProps {
  suggestedAdjustment: SuggestedAdjustment | null;
}

const ReviewSuggestionData: FC<ReviewSuggestionDataProps> = ({ suggestedAdjustment }) => {
  const { id: teamId } = useAppSelector(selectCurrentTeam);

  const getDetails = () => {
    const { transactionDetails, refundDetails, disputeDetails } = suggestedAdjustment;
    switch (suggestedAdjustment.type) {
      case SuggestedAdjustmentType.DISPUTE:
        return disputeDetails;
      case SuggestedAdjustmentType.REFUND:
        return refundDetails;
      case SuggestedAdjustmentType.OTHER:
        return transactionDetails;
      case SuggestedAdjustmentType.DELAYED_PAYMENT:
        return transactionDetails;
      case SuggestedAdjustmentType.TIP:
        return transactionDetails;
      default:
        return null;
    }
  };

  const renderRelatedDetails = () => {
    const { transactionDetails, refundDetails, invoiceDetails, jobDetails, disputeDetails } = suggestedAdjustment ?? {};

    const renderDetails = (data1, data2, dateString, redirectUrl) => {
      return (
        <div className="flex cursor-pointer flex-wrap items-center gap-2">
          <div className="text-sbase font-semibold text-tertiaryText">{data1}</div>
          <span className="text-[#BDBDBD]">•</span>
          <span className="text-sbase capitalize text-primaryText">{data2}</span>
          <span className="text-[#BDBDBD]">•</span>
          <span className="text-sbase text-primaryText">
            {dateString ? DateUtils.getDateInFormat({ date: new Date(dateString), dateFormat: 'dd MMM yyyy' }) : '-'}
          </span>
          <RedirectIcon
            className="h-4 w-4 text-[#3876BB]"
            onClick={() => openInNewTab(redirectUrl.replace(':teamId', teamId))}
          />
        </div>
      );
    };

    return (
      <div className="mt-4">
        <h3 className="mb-2 text-sbase font-medium text-primaryText">Related documents</h3>
        <div className="space-y-3">
          {transactionDetails?.id &&
            renderDetails(
              `Payment ${transactionDetails.id}`,
              transactionDetails.paymentNetwork
                ? `${transactionDetails.paymentNetwork} ${transactionDetails.cardLast4}`
                : transactionDetails.paymentMethod?.toLowerCase(),
              transactionDetails.date,
              routesPath.RECEIPT_BY_ID.replace(':rootReceiptId', transactionDetails.id)
            )}
          {refundDetails?.ID &&
            renderDetails(
              `Refund ${refundDetails.ID}`,
              getAmountWithCurrency(refundDetails.amount),
              refundDetails.date,
              routesPath.RECEIPT_BY_ID.replace(':rootReceiptId', refundDetails.ID)
            )}
          {disputeDetails.disputeId &&
            renderDetails(
              `Dispute ${disputeDetails.disputeId}`,
              getAmountWithCurrency(disputeDetails.disputeAmount),
              disputeDetails.createdAt,
              routesPath.DISPUTE_BY_ID.replace(':rootDisputeId', disputeDetails.disputeId)
            )}
          {invoiceDetails?.id &&
            renderDetails(
              `Invoice ${invoiceDetails.invoiceNumber}`,
              getAmountWithCurrency(invoiceDetails.amount),
              suggestedAdjustment.createdAt,
              routesPath.INVOICE_BY_ID.replace(':rootInvoiceId', invoiceDetails.id)
            )}
          {jobDetails?.jobId &&
            renderDetails(
              `Job ${jobDetails.jobNumber}`,
              jobDetails.title,
              jobDetails.date,
              routesPath.JOB_BY_ID.replace(':rootJobId', jobDetails.jobId)
            )}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="text-base font-bold text-heading">
          {getSuggestedAdjustmentTitle(suggestedAdjustment?.type)}
          {suggestedAdjustment?.type === SuggestedAdjustmentType.OTHER && (
            <>
              <span> - </span>
              <span className="text-base capitalize text-heading">
                {suggestedAdjustment?.transactionDetails?.paymentMethod?.toLowerCase()}
              </span>
            </>
          )}
          {/* {suggestedAdjustment?.type === SuggestedAdjustmentType.REFUND && (
            <>
              <span className="text-base capitalize text-heading">
                {getAmountWithCurrency(suggestedAdjustment?.refundDetails?.amount)}
              </span>
            </>
          )} */}
        </div>
        <div className="text-sbase text-primaryText">{suggestedAdjustment?.description}</div>
        {getDetails() && (
          <div>
            <SuggestedAdjustmentDataCard details={getDetails()} type={suggestedAdjustment.type} />
          </div>
        )}
      </div>
      {renderRelatedDetails()}
    </div>
  );
};

export default ReviewSuggestionData;
